import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import MainAPI from '../assets/APIs/mainApi';

function TopHeader() {

    const [selectData, setSelectData] = useState(MainAPI.TopLink)
    const [subSelect, setSubSelect] = useState()
    const [isSetSelectID, setSelectID] = useState(true)
    const officeSelect = (e) => {
        const value = e.target.value
        setSubSelect(value)
        if (!value == "") {
            setSelectID(false)
        } else {
            setSelectID(true)
        }
    }

    const officeTypeBTN = document.getElementById('officeTypeBTN')
    const [selectedWebsite, setSelectedWebsite] = useState('');
    const getSiteURL = (e) => {
        const url = e.target.value;
        setSelectedWebsite(url)
    }



    function handleWebsiteSelection(e) {
        setSelectedWebsite(e.target.value);
    }

    function handleGoButtonClick() {
        window.location.replace(selectedWebsite);
    }


    return (
        <>
            <div className="topHeader Bg-color-1">
                <div className="row justify-space-between align-items-center">
                    <div className="col-6">
                        <div className="row">
                            <div className="slide-panel-btns">
                                <div className="slide-panel-button">
                                    <a href="http://www.bangladesh.gov.bd/" target="_blank" title="বাংলাদেশ জাতীয় তথ্য বাতায়ন">বাংলাদেশ জাতীয় তথ্য বাতায়ন</a>
                                </div>
                            </div>
                            <div id="div-lang">
                                <div className="sectionPart">
                                    <select onInput={officeSelect} name="" id="offieceFSTSelecct" >
                                        {
                                            selectData.typeof.map((e) => {
                                                return (
                                                    <>
                                                        <option value={e.value}>{e.tittle}</option>
                                                    </>
                                                )
                                            })
                                        }
                                    </select>
                                    {
                                        isSetSelectID
                                            ?
                                            <>
                                            </>
                                            :
                                            <>
                                                {
                                                    <select name="" onClick={getSiteURL} >
                                                        {
                                                            selectData.ministry.map((e) => {
                                                                return (
                                                                    <>
                                                                        <option value={e.value}>{e.tittle}</option>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                }
                                            </>
                                    }
                                    <button onClick={handleGoButtonClick} className='Bg-color-2 gn-btn p-2' >Go</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row align-items-center">
                            <input type="text" className='searchBar' />
                            <button type="submit" className='gn-btn mx-2 p-2'>Search</button>
                            <button type="button" className='p-2'>English</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TopHeader
